import React, { Component } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { UncontrolledTooltip, Badge } from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";
import { startOfQuarter } from "date-fns";
import { goToName } from "../oro-module/commonFunctions";
import { indexOf } from "lodash";

function lastFridayForMonth(monthMoment) {
  var lastDay = monthMoment.endOf('month').startOf('day');
  switch (lastDay.day()) {
    case 6:
      return lastDay.subtract(1, 'days');
    default:
      return lastDay.subtract(lastDay.day() + 2, 'days');
  }
}


const getCleanDates = (dstr, field) => {
  let d1 = dstr.split(" " + field);
  let d3;
  if (d1.length > 1) {
    let d2 = d1[0].split(' ');
    d3 = d2[d2.length - 1].trim();
  } else {
    d3 = 0;
  }

  return d3 && d3 != '' ? d3 : 0;
}

const extractTimeDelta = ({ timeDeltaString, from }) => {
  let con;
  let days = getCleanDates(timeDeltaString, 'days');
  let months = getCleanDates(timeDeltaString, 'months');
  let years = getCleanDates(timeDeltaString, 'years');
  if (timeDeltaString.indexOf('from now') != -1) {
    con = moment(new Date(from)).add(years, 'year').add(months, 'month').add(days, 'day');
  } else if (timeDeltaString.indexOf('ago') != -1) {
    con = moment(new Date(from)).subtract(years, 'year').subtract(months, 'month').subtract(days, 'day');
  }
  return new Date(con);
}

function getDefaultDate2(val, props, from = new Date()) {
  let convertedDate = "";
  let fe = new Date().getMonth() + 1 < 4 ? new Date(new Date().getYear() - 1 + 1901, 2, 31) : new Date(new Date().getYear() + 1901, 2, 31);
  let def = {
    sd: props.parentProps.parentState.session_date,
    y: new Date(moment().subtract(1, 'days')),
    n: new Date(),
    t: new Date(moment().add(1, 'days')),
    qs: new Date(moment().startOf('quarter')),
    qe: new Date(moment().endOf('quarter')),
    lqs: new Date(moment().startOf('quarter').subtract(3, 'month')),
    lqe: new Date(moment().endOf('quarter').subtract(3, 'month')),
    ys: new Date(moment().startOf('year')),
    ye: new Date(moment().endOf('year')),
    fs: new Date().getMonth() + 1 < 4 ? new Date(new Date().getYear() - 1 + 1900, 3, 1) : new Date(new Date().getYear() + 1900, 3, 1),
    fe: fe,
    lfe: new Date(moment(fe).subtract(1, 'year')),
    ms: new Date(moment().startOf('month')),
    me: new Date(moment().endOf('month')),
    // lf: ( lastFridayForMonth(moment()) <= moment() ) ? new Date(lastFridayForMonth(moment())) : new Date(lastFridayForMonth(moment().subtract(1,'months')))
  };

  if (val == 'sessiondate') {
    convertedDate = props.parentProps.parentState.session_date;
  }

  // else if (val.indexOf('ago') != -1) {
  //   convertedDate = new Date(new Date().getTime() - parseInt(val.split(' ')[0]))
  // } 
  else if (val && def[val]) {
    convertedDate = def[val];
  } else if (val.indexOf('from') != -1 || val.indexOf('ago') != -1) {
    convertedDate = extractTimeDelta({ timeDeltaString: val, from });
  } else if (val) {
    convertedDate = moment(val, 'DD/MM/YYYY');
  } else {
    convertedDate = props.parentState.pageData.val;
  }
  return convertedDate;
}

function getDefaultDate(val, props, from = new Date()) {
  let convertedDate = "";
  let fe = new Date().getMonth() + 1 < 4 ? new Date(new Date().getYear() - 1 + 1901, 2, 31) : new Date(new Date().getYear() + 1901, 2, 31);
  let def = {
    sd: props.parentProps.parentState.session_date,
    y: new Date(moment().subtract(1, 'days')),
    n: new Date(),
    t: new Date(moment().add(1, 'days')),
    qs: new Date(moment().startOf('quarter')),
    qe: new Date(moment().endOf('quarter')),
    lqs: new Date(moment().startOf('quarter').subtract(3, 'month')),
    lqe: new Date(moment().endOf('quarter').subtract(3, 'month')),
    ys: new Date(moment().startOf('year')),
    ye: new Date(moment().endOf('year')),
    fs: new Date().getMonth() + 1 < 4 ? new Date(new Date().getYear() - 1 + 1900, 3, 1) : new Date(new Date().getYear() + 1900, 3, 1),
    fe: fe,
    lfe: new Date(moment(fe).subtract(1, 'year')),
    ms: new Date(moment().startOf('month')),
    me: new Date(moment().endOf('month')),
    // lf: ( lastFridayForMonth(moment()) <= moment() ) ? new Date(lastFridayForMonth(moment())) : new Date(lastFridayForMonth(moment().subtract(1,'months')))
  };

  if (val == 'sessiondate') {
    convertedDate = props.parentProps.parentState.session_date;
  }

  // else if (val.indexOf('ago') != -1) {
  //   convertedDate = new Date(new Date().getTime() - parseInt(val.split(' ')[0]))
  // } 
  else if (val && def[val]) {
    convertedDate = moment(def[val]).toISOString();
  } else if (val.indexOf('from') != -1 || val.indexOf('ago') != -1) {
    convertedDate = extractTimeDelta({ timeDeltaString: val, from });
  } else if (val) {
    convertedDate = moment(val, 'DD/MM/YYYY');
  } else {
    convertedDate = props.parentState.pageData.val;
  }

  let fdate = convertedDate;
  try {
    fdate = convertedDate.substring(0, 10) + "T00:00:00";
  } catch (err) {
    fdate = moment(convertedDate).format("YYYY-MM-DDT00:00:00");
  }

  return fdate;
}

function getMomentDiff(converted) {

  let currentage
  if (converted) {
    let diffnum = moment(converted).diff(moment(), 'milliseconds');
    let diff = moment.duration(diffnum);
    let inText = " From Now";
    if (diffnum < 0) {
      inText = " Ago";
    }
    currentage = (diff.years() != 0 ? Math.abs(diff.years()) + " Years, " : "") + (diff.months() != 0 ? Math.abs(diff.months()) + " Months, " : "") + (diff.days() != 0 ? Math.abs(diff.days()) + " Days" : "") + inText;
  } else {
    currentage = ""
  }

  return currentage;
}

const dateShortcuts = (val, props) => {
  let fe = new Date().getMonth() + 1 < 4 ? new Date(new Date().getYear() - 1 + 1901, 2, 31) : new Date(new Date().getYear() + 1901, 2, 31);
  let def = {
    sd: new Date(props.parentProps.parentState.session_date),
    y: new Date(moment().subtract(1, 'days')),
    n: new Date(),
    t: new Date(moment().add(1, 'days')),
    qs: new Date(moment().startOf('quarter')),
    qe: new Date(moment().endOf('quarter')),
    lqs: new Date(moment().startOf('quarter').subtract(3, 'month')),
    lqe: new Date(moment().endOf('quarter').subtract(3, 'month')),
    ys: new Date(moment().startOf('year')),
    ye: new Date(moment().endOf('year')),
    fs: new Date().getMonth() + 1 < 4 ? new Date(new Date().getYear() - 1 + 1900, 3, 1) : new Date(new Date().getYear() + 1900, 3, 1),
    fe: fe,
    lfe: new Date(moment(fe).subtract(1, 'year')),
    ms: new Date(moment().startOf('month')),
    me: new Date(moment().endOf('month')),
    lf: (lastFridayForMonth(moment()) <= moment()) ? new Date(lastFridayForMonth(moment())) : new Date(lastFridayForMonth(moment().subtract(1, 'months')))
  };

  return def[val];
}

//(selectedYear-1)
class MagicDateCustom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: ""
    };
  }

  setValue = (value) => {
    let { onLeave } = this.props.component;
    // console.log({ N: this.props.component.name, value });
    try {
      // if (value && value.indexOf('18:30:00') != -1) {
      value = moment(value).format('YYYY-MM-DD HH:mm:ss');
      // }
    } catch (err) {
      value = value.format('YYYY-MM-DD HH:mm:ss');
    }

    this.props.liftState(this.props.component, value);
    if (onLeave) {
      onLeave.map(({ action, target }) => {
        let nv = getDefaultDate(action, this.props, value);
        this.props.liftState({ name: target }, nv);
      });
    }
  }

  handleChange = (e) => {
    let x = this.props.parentState.errorMessages;
    x[this.props.component.name] = "";
    this.props.liftGlobalState({ name: "errorMessages" }, x);
    let { convertedTo } = this.props.component

    let dateNew;
    if (e) {
      dateNew = e.toISOString()
    } else {
      dateNew = ""
    }
    if (convertedTo) {
      let currentage = getMomentDiff(e)
      this.props.liftState({ name: convertedTo }, currentage);
    }
    this.setValue(dateNew);
  }

  handleInputChange = value => {
    let { displayFormat, outputFormat, convertedTo } = this.props.component;
    let converted = dateShortcuts(value, this.props) ? dateShortcuts(value, this.props) : '';
    if (value.length == 6 || value.length == 8) {
      let ipformat;
      value.length == 6 ? (ipformat = "DDMMYY") : (ipformat = "DDMMYYYY");
      converted = moment(value, ipformat)
      if (convertedTo) {
        let currentage = getMomentDiff(converted);
        this.props.liftState({ name: convertedTo }, currentage);
      }
    }
    this.setValue(converted);

  };

  componentDidMount() {
    let { fileFolder, formState, modalname, pageData } = this.props.parentState;
    let { name, displayData, defaultValue } = this.props.component;
    let def = this.props.component.default;
    if (
      pageData &&
      ((!modalname && !pageData[name]) || (modalname && (!pageData[modalname] || !pageData[modalname][name]))) &&
      def &&
      !def.parent && !fileFolder.isOpen
    ) {
      let dateNew = getDefaultDate(def, this.props);
      // this.props.liftState(this.props.component, dateNew);
      this.setValue(dateNew);
    }
  }

  render() {
    // restrictions:{min:{type:fixed/var,val:date/days,months,years ago},max:{},skip:[{type:'week',val:'sunday'},{type:'month',val:3}]}

    const {
      name,
      placeHolder,
      dateType,
      displayFormat,
      isReadOnly, insertonly, next_field
    } = this.props.component;

    let { minDate, maxDate } = this.props.component;

    let { conditionalRender } = this.props;

    let { LocalVars } = this.props.parentState;
    let { compressed, ShowHistory } = LocalVars;

    let { currentPage, fileFolder, formState, pageData, openmodals, modalname, errorMessages } = this.props.parentState;
    let isReadOnly1 = false;
    if ((formState != 'edit' && fileFolder.isOpen) || isReadOnly == true || (formState == 'edit' && isReadOnly == 'edit' && fileFolder.isOpen) || this.props.conditionalRender == 'readonly') {
      isReadOnly1 = true;
    }

    let bv;
    if (modalname && pageData[modalname]) {
      bv = pageData[modalname][name]
        ? pageData[modalname][name]
        : null;
    } else {
      bv = pageData[name]
        ? pageData[name]
        : null;
    }

    if (maxDate) {
      maxDate = getDefaultDate2(maxDate, this.props);
    }
    if (minDate) {
      minDate = getDefaultDate2(minDate, this.props);
    }

    let boxvalue;
    if (bv) {
      boxvalue = new Date(bv);
      if (isNaN(boxvalue.getTime())) {
        boxvalue = dateShortcuts(bv, this.props);
        // this.props.liftState({ name }, boxvalue);
        this.setValue(boxvalue);

      }
    }

    let currentError;
    if (errorMessages) {
      if (modalname && errorMessages[modalname] && errorMessages[modalname][name]) {
        currentError = errorMessages[modalname][name];
      } else if (!modalname && errorMessages[name]) {
        currentError = errorMessages[name];
      }
    }
    if (insertonly && !ShowHistory) {
      isReadOnly1 = true;
    }
    if (pageData.actionbuttons) {
      isReadOnly1 = true;
    }
    let is_time = false;
    if (displayFormat.indexOf(":") != -1) {
      is_time = true;
    }

    return (
      <div id={name} className={`form-group ${this.props.component.widths.parent}`}>
        {conditionalRender && conditionalRender != 'blank' &&
          <div className="input-group input-group-sm">
            {this.props.component.prepend && (
              <div className="input-group-prepend">
                <div className="input-group-text">
                  {this.props.component.prepend}
                </div>
              </div>
            )}

            {!is_time && (!dateType || dateType === "default") && (
              <DatePicker
                className={`${!compressed ? "input-compressed" : ""} col-12 form-control form-control-sm primary ${currentError
                  ? "validationErrorBox"
                  : ""
                  }`}
                autoComplete="off"
                selected={boxvalue}
                readOnly={isReadOnly1}
                dateFormat={displayFormat}
                onChange={this.handleChange}
                name={name}
                placeholderText={placeHolder}
                minDate={minDate}
                maxDate={maxDate}
                onKeyDown={(e) => goToName(e, next_field, name, this)}

              />
            )}
            {!is_time && dateType == "ontype" && (
              <DatePicker
                className={`${!compressed ? "input-compressed" : ""} col-12 form-control form-control-sm primary ${currentError
                  ? "validationErrorBox"
                  : ""
                  }`}
                // showTimeSelect
                // showTimeSelectOnly // Add monthpicker, DOW picker, week picker.
                autoComplete="off"
                readOnly={isReadOnly1}
                name={name}
                selected={boxvalue}
                placeholderText={placeHolder}
                onChange={this.handleChange}
                minDate={minDate}
                maxDate={maxDate}
                strictParsing
                onChangeRaw={event => this.handleInputChange(event.target.value)}
                dateFormat={displayFormat} //YYYY/MM/DD for 2017/02/01
                // showMonthYearDropdown
                showMonthDropdown
                showYearDropdown
                isClearable={isReadOnly1 ? false : true}
                onKeyDown={(e) => goToName(e, next_field, name, this)}

                timeFormat="HH:mm"
              // timeIntervals={15}
              />
            )}

            {is_time && dateType == "ontype" && (
              <DatePicker
                className={`${!compressed ? "input-compressed" : ""} col-12 form-control form-control-sm primary ${currentError
                  ? "validationErrorBox"
                  : ""
                  }`}
                showTimeSelect
                // showTimeSelectOnly // Add monthpicker, DOW picker, week picker.
                autoComplete="off"
                readOnly={isReadOnly1}
                name={name}
                selected={boxvalue}
                placeholderText={placeHolder}
                onChange={this.handleChange}
                minDate={minDate}
                maxDate={maxDate}
                strictParsing
                onChangeRaw={event => this.handleInputChange(event.target.value)}
                dateFormat={displayFormat} //YYYY/MM/DD for 2017/02/01
                // showMonthYearDropdown
                showMonthDropdown
                showYearDropdown
                isClearable={isReadOnly1 ? false : true}
                onKeyDown={(e) => goToName(e, next_field, name, this)}


                timeFormat="HH:mm"
                popperPlacement="bottom"
                popperModifiers={{
                  flip: {
                    behavior: ["bottom"] // don't allow it to flip to be above
                  },
                  preventOverflow: {
                    enabled: false // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
                  },
                  hide: {
                    enabled: false // turn off since needs preventOverflow to be enabled
                  }
                }}
              // timeIntervals={15}
              />
            )}
            {dateType == "monthYear" && (
              <DatePicker
                className={`${!compressed ? "input-compressed" : ""} col-12 form-control form-control-sm primary ${currentError
                  ? "validationErrorBox"
                  : ""
                  }`}
                // showTimeSelectOnly // Add monthpicker, DOW picker, week picker.
                autoComplete="off"
                readOnly={isReadOnly1}
                name={name}
                selected={boxvalue}
                placeholderText={placeHolder}
                onChange={this.handleChange}
                minDate={minDate}
                maxDate={maxDate}
                strictParsing
                onChangeRaw={event => this.handleInputChange(event.target.value)}
                dateFormat={displayFormat} //YYYY/MM/DD for 2017/02/01
                // showMonthYearDropdown
                showMonthDropdown
                showYearDropdown
                isClearable={isReadOnly1 ? false : true}
                onKeyDown={(e) => goToName(e, next_field, name, this)}
                showMonthYearPicker



                popperPlacement="bottom"
                popperModifiers={{
                  flip: {
                    behavior: ["bottom"] // don't allow it to flip to be above
                  },
                  preventOverflow: {
                    enabled: false // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
                  },
                  hide: {
                    enabled: false // turn off since needs preventOverflow to be enabled
                  }
                }}
              // timeIntervals={15}
              />
            )}

          </div>
        }
      </div>
    );
  }
}

export default MagicDateCustom;